const GENDER = {
    MALE: 'male',
    FEMALE: 'female',
    OTHER: 'other',
};

const USER_ROLE_DEFAULT = {
    ADMIN: "admin",
    PHYSICIAN: "physician",
    NURSE: "nurse",
    RECEPTIONIST: "receptionist",
};

const COUNTRIES = [
    "Guyana",
    "Suriname",
    "Trinidad and Tobago",
    "Barbados",
    "Jamaica",
    "Bahamas",
    "Haiti",
    "Dominican Republic",
    "Cuba",
    "Puerto Rico",
    "United States",
    "Canada",
    "United Kingdom",
    "Brazil",
    "Venezuela",
    "Colombia",
    "Argentina",
    "Chile",
    "Peru",
    "Mexico",
    "France",
    "Germany",
    "Spain",
    "Italy",
    "Netherlands",
    "Portugal",
    "India",
    "China",
    "Japan",
    "Australia",
    "New Zealand",
    "South Africa",
    "Nigeria",
    "Ghana",
    "Kenya",
    "Other",
];

// Module keys + labels are NOT defined here — the server's capability catalog
// (config/capabilities.js, served via GET /api/permissions) is the single
// source of truth. The Permissions editor renders from it.

export {
    USER_ROLE_DEFAULT,
    GENDER,
    COUNTRIES,
};
